const ContactList = () => {
  return (
    <div className='pt-32'>
        <div className="relative max-w-2xl mx-auto bg-white shadow-md rounded-lg border border-gray-200 p-6 mb-16">
            <div className="px-4 sm:px-0">
                <h3 className="text-2xl font-semibold text-gray-900">Contact Us & Opening Hours</h3>
            </div>
            <div className="mt-6 border-t border-gray-300">
                <dl className="divide-y divide-gray-200">
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt className="text-lg font-medium text-gray-900">Address</dt>
                        <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                            <a className='pb-1' href='https://maps.app.goo.gl/TxGdyT1cwkW8ogy29'>Bridgnorth Road, Stourton, Kinver, West Midlands, DY7 5BL</a>
                        </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt className="text-lg font-medium text-gray-900">Opening Times</dt>
                        <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">Monday: 12pm - Late<br/>Tuesday - Saturday: 8am - Late<br/>Sunday: 8am - 11pm</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt className="text-lg font-medium text-gray-900">Food Service Hours</dt>
                        <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">Monday: 12pm - 2:30pm | 5:30pm - 8:15pm<br/>Tuesday - Thursday: 8am - 11am | 12pm - 2:30pm | 5:30pm - 8:15pm<br/>Friday - Saturday: 8am - 11am | 12pm - 8:15pm<br/>Sunday: 8am - 11am | 12pm - 4:30pm</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt className="text-lg font-medium text-gray-900">Pizza Service Hours</dt>
                        <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">All times are weather dependant. Please contact us for confirmation<br/>Wednesday - Friday: 5pm - 8:30pm<br/>Saturday: 1pm - 8:30pm<br/>Sunday: 1pm - 5:30pm</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt className="text-lg font-medium text-gray-900">Phone</dt>
                        <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                            <a className='pb-1' href='tel:01384 872614'>01384 872614</a>
                        </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt className="text-lg font-medium text-gray-900">General Enquiries</dt>
                        <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                            <a className='pb-1' href='mailto:foxinnstourton@gmail.com'>foxinnstourton@gmail.com</a>
                        </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt className="text-lg font-medium text-gray-900">Weddings & Events</dt>
                        <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                            <a className='pb-1' href='mailto:events.foxinnstourton@gmail.com'>events.foxinnstourton@gmail.com</a>
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
  )
}

export default ContactList